import React, { useState } from 'react';
import { Route } from 'react-router-dom';
import WorkstationOverviewPage from '../Order/WorkstationOverviewPage';
import RecyclePage from '../Recycle/RecyclePage';
import RecyclingHistoryPage from '../Recycle/RecyclingHistoryPage';
import OrderHistoryPage from '../Order/OrderHistoryPage';
import OrderDetailPage from '../Order/OrderDetailPage';
import OrderOverviewPage from '../Order/OrderOverviewPage';
import CarpentryOrderOverviewPage from '../Order/CarpentryOrderOverviewPage';
import UserOverviewPage from '../User/UserOverviewPage';
import { SyncPage } from '../Order/SyncPage';
import SettingsPage from './SettingsPage';
import HeaderBar from '../../Shared/HeaderBar';
import { PrivateRoute } from '../../Pages/Auth/PrivateRoute';
import { Callback } from '../Auth/Callback';
import { Logout } from '../Auth/Logout';
import { LogoutCallback } from '../Auth/LogoutCallback';
import { SilentRenew } from '../Auth/SilentRenew';
import { makeStyles } from "@material-ui/core";
import NavDrawer from '../../Shared/NavDrawer';
import { drawerWidth } from '../../../Config/constants';
import QualityChecksPage from '../QualityCheck/QualityChecksPage';
import PlateSamplingPage from '../QualityCheck/PlateSamplingPage';
import { AuthConsumer } from "../../../Helpers/auth.provider";
import IdleController from '../../Shared/IdleController';
import { ScaleOverviewPage } from '../Scale/ScaleOverviewPage';
import ProductionStatePage from '../ProductionState/ProductionStatePage';
import { dataService } from '../../../Services/data.service';
import { systemParameters } from '../../../Config/constants';
import { toast } from 'react-toastify';

// import machineStandStill from './Reducers/machineStandStill/machineStandStill.js';
export default function IndexPage(props) {
  const [dataFetched, setDataFetched] = useState(false);

  const setInitialState = () => {
    let neededSystemParameters = [systemParameters.Silos, systemParameters.ShopfloorAppSettings];
    // let neededPopups = [popupDefinitions.REPORT_PROBLEM_POPUP, popupDefinitions.OPERATOR_INSTRUCTIONS];

    Promise.all([
      dataService.getSystemParametersByIdList(neededSystemParameters)
    ]).then((results) => {
      if (!dataFetched) {
        let settings = results[0];
        props.actions.setSystemParameters(settings);
        setDataFetched(true);
      }
    }).catch((error) => { toast.error(error, { position: 'top-center' }) });
  }
  const classes = useStyles();
  return (
    <React.Fragment>
      <AuthConsumer>
        {({ isAuthenticated }) => {
          if (isAuthenticated()) {
            setInitialState()

            return <React.Fragment>
              <HeaderBar className={classes.headerBar} actions={props.actions} {...props}></HeaderBar>
              <NavDrawer actions={props.actions} {...props}></NavDrawer>
            </React.Fragment>
          }
        }}
      </AuthConsumer>
      <main className={classes.content}>
        <div className={classes.rootClass} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bgr-logo.svg), linear-gradient(#EFEFEF,#FFFFFF)`, backgroundRepeat: "no-repeat", backgroundPosition: 'right bottom', backgroundSize: '40%,100%', width: "max-content", minWidth: "100%", zIndex: "0" }}>
          <IdleController {...props}></IdleController>
          <Route exact={true} path="/signin-oidc" component={Callback} />
          <Route exact={true} path="/logout" component={Logout} />
          <Route exact={true} path="/signout-oidc" component={LogoutCallback} />
          <Route exact={true} path="/silentrenew" component={SilentRenew} />
          <PrivateRoute path="/history" component={OrderHistoryPage} />
          <PrivateRoute path="/settings" component={() => <SettingsPage i18n={props.i18n} ></SettingsPage>} />
          <PrivateRoute path="/order/:id/:orderLineId" component={(matchProps) => <OrderDetailPage {...matchProps} {...props} actions={props.actions}></OrderDetailPage>} />
          <PrivateRoute path="/sampling/:id/:barcode/:progress/:samplesTaken/:machineId/:origin/:orderLineId" component={(matchProps) => <PlateSamplingPage {...matchProps} {...props} actions={props.actions}></PlateSamplingPage>} />
          <PrivateRoute path="/productionstate/:id/:machineId/:orderLineId" component={(matchProps) => <ProductionStatePage {...matchProps} {...props} actions={props.actions}></ProductionStatePage>} />
          <PrivateRoute path="/qualitychecks/:progress/:id/:orderLineId" component={(matchProps) => <QualityChecksPage {...matchProps} {...props} actions={props.actions}></QualityChecksPage>} />
          <PrivateRoute path="/workstation" component={(matchProps) => <OrderOverviewPage {...matchProps}  {...props}></OrderOverviewPage>} />
          <PrivateRoute path="/carpentryWorkstation" component={(matchProps) => <CarpentryOrderOverviewPage {...matchProps}  {...props}></CarpentryOrderOverviewPage>} />
          <PrivateRoute path="/users" component={(matchProps) => <UserOverviewPage  {...matchProps}  {...props}></UserOverviewPage>} />
          <PrivateRoute path="/sync" component={() => <SyncPage></SyncPage>} />
          <PrivateRoute exact path="/" component={() => <WorkstationOverviewPage {...props}></WorkstationOverviewPage>} />
          <PrivateRoute exact path="/recycle" component={(matchProps) => <RecyclePage {...matchProps} {...props}></RecyclePage>} />
          <PrivateRoute exact path="/recyclingHistory" component={(matchProps) => <RecyclingHistoryPage {...matchProps} {...props}></RecyclingHistoryPage>} />
          <PrivateRoute exact path="/scale" component={() => <ScaleOverviewPage {...props}></ScaleOverviewPage>} />
          <div className={classes.footer}>
            <div className={classes.powered}>Powered by Flagstone </div>
            {/* {props.general.systemParameters && props.general.systemParameters.length > 0 &&
              <div className={classes.powered}>{(props.general.systemParameters.find(x => x.id === systemParameters.VersionNumber) !== null && props.general.systemParameters.find(x => x.id === systemParameters.VersionNumber) !== undefined) && "v." + props.general.systemParameters.find(x => x.id === systemParameters.VersionNumber).value }  </div>
            } */}
          </div>
        </div>
      </main>
    </React.Fragment>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    // overflow: "auto",
    height: '100%',
  },
  backdrop: {
    zIndex: 100,
    color: '#fff'
  },
  rootClass: {
    display: 'flex',
    height: 'fit-content',
    minHeight: '100%',
    width: '100%',
    marginTop: "45px",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  background: {
    height: '100vh'
  },
  root: {
    display: 'flex',
    height: '100%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: "calc(100% - 50px)",
    height: 'calc(100% - 45px)',

    // [theme.breakpoints.down('sm')]: {
    //   height: 'calc(100% - 80px)',
    // },
    display: 'flex',
    flexDirection: "row"
  },
  powered: {
    height: "20px",
    width: "150px",
    position: "fixed",
    bottom: "70",
    right: "40px",
    overflow: "hidden",
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: 'Medium',
    color: "#E8E8E8",
    zIndex: "-1"
  }
}));